/* RESPONSIBLE TEAM: team-ai-agent-2 */

export type GroupSummaryWireFormat = {
  id: string;
  group_name: string;
  last_used_topic_id?: string;
  last_modified_at?: string;
  last_modified_by_admin?: number;
};

export class GroupSummary {
  id: number;
  name: string;
  lastUsedTopicId?: string;
  lastModifiedAt?: string;
  lastModifiedByAdminId?: number;

  constructor(
    id: number,
    name: string,
    lastModifiedAt?: string,
    lastModifiedByAdminId?: number,
    lastUsedTopicId?: string,
  ) {
    this.id = id;
    this.name = name;
    this.lastModifiedAt = lastModifiedAt;
    this.lastModifiedByAdminId = lastModifiedByAdminId;
    this.lastUsedTopicId = lastUsedTopicId;
  }

  static deserialize(data: GroupSummaryWireFormat): GroupSummary {
    return new GroupSummary(
      Number(data.id),
      data.group_name,
      data.last_modified_at,
      data.last_modified_by_admin,
      data.last_used_topic_id,
    );
  }
}
